import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { UserSettingsService } from '@service/userSettings/user-settings.service';

@Component({
	selector: 'app-power-units-filter',
	templateUrl: './power-units-filter.component.html',
	styleUrls: ['./power-units-filter.component.scss'],
})
export class PowerUnitsFilterComponent implements OnInit {
	@Input() isLoadingSearchResults: boolean = true;
	@Input() searchTruckForm: any = null;
	@Output() trucksCountChange: EventEmitter<any> = new EventEmitter();
	trucksCount = null;
	private debouncer: Subject<any> = new Subject<any>();

	constructor(public userSettings: UserSettingsService) {}

	ngOnInit() {
		this.trucksCount = this.userSettings.MINIMUM_TRUCK_COUNT;
		this.debouncer.pipe(debounceTime(500)).subscribe((value) => this.trucksCountChange.emit(value));
		this.debouncer.next(this.trucksCount);
	}

	filterChanged() {
		this.debouncer.next(this.trucksCount);
	}
}
